import React, { CSSProperties } from 'react';
import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemType } from '@src/framework/workbench/drawer/constants';
import {
    horizontalCenter, horizontalJustify,
    horizontalLeft, horizontalRight, horizontalDistribute,
    verticalBottom, verticalCenter, verticalTop,
} from '@editor/src/js/constants/toolbar-data';
import { increaseIndent, reduceIndent } from '@src/framework/workbench/ui/indentation/config';
import {
    HORIZONTAL_LEFT_ICON,
    HORIZONTAL_RIGHT_ICON,
    HORIZONTAL_CENTER_ICON,
    HORIZONTAL_JUSTIFY_ICON,
    HORIZONTAL_DISTRIBUTE_ICON,
    VERTICAL_TOP_ICON,
    VERTICAL_CENTER_ICON,
    VERTICAL_BOTTOM_ICON,
    INCREASE_INDENT_ICON,
    REDUCE_INDENT_ICON,
} from '@src/framework/workbench/drawer/image';
import Style from '@framework/workbench/drawer/ui/index.less';
import { COMMON_STYLE, ALIGN_BUTTON_STYLE } from '@framework/workbench/drawer/common/config';

export const FORM_CONFIGS_H_ALIGN: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: horizontalLeft.id,
        options: {
            icon: <img src={HORIZONTAL_LEFT_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: horizontalLeft.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
    {
        type: FormItemType.BUTTON,
        name: horizontalCenter.id,
        options: {
            icon: <img src={HORIZONTAL_CENTER_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: horizontalCenter.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
    {
        type: FormItemType.BUTTON,
        name: horizontalRight.id,
        options: {
            icon: <img src={HORIZONTAL_RIGHT_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: horizontalRight.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
    {
        type: FormItemType.BUTTON,
        name: horizontalJustify.id,
        options: {
            icon: <img src={HORIZONTAL_JUSTIFY_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: horizontalJustify.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
    {
        type: FormItemType.BUTTON,
        name: horizontalDistribute.id,
        options: {
            icon: <img src={HORIZONTAL_DISTRIBUTE_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: horizontalDistribute.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
];

export const FORM_CONFIGS_V_ALIGN: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: verticalTop.id,
        options: {
            icon: <img src={VERTICAL_TOP_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: ALIGN_BUTTON_STYLE,
        tooltip: verticalTop.tipMsg,
        preventFocus: true,
    },
    {
        type: FormItemType.BUTTON,
        name: verticalCenter.id,
        options: {
            icon: <img src={VERTICAL_CENTER_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: ALIGN_BUTTON_STYLE,
        tooltip: verticalCenter.tipMsg,
        preventFocus: true,
    },
    {
        type: FormItemType.BUTTON,
        name: verticalBottom.id,
        options: {
            icon: <img src={VERTICAL_BOTTOM_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: ALIGN_BUTTON_STYLE,
        tooltip: verticalBottom.tipMsg,
        preventFocus: true,
    },
];

export const FORM_CONFIGS_INDENT: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: reduceIndent.id,
        options: {
            icon: <img src={REDUCE_INDENT_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: ALIGN_BUTTON_STYLE,
        tooltip: reduceIndent.tipMsg,
        preventFocus: true,
    },
    {
        type: FormItemType.BUTTON,
        name: increaseIndent.id,
        options: {
            icon: <img src={INCREASE_INDENT_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: ALIGN_BUTTON_STYLE,
        tooltip: increaseIndent.tipMsg,
        preventFocus: true,
    },
];
